import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Consistent navy/gold header used on every letter-size printable
 * (Contract, Statement, Examples, Roadmap, Specs, ROI, Onboarding, etc).
 * Pulls dealership name from settings so it flows through the Personalize
 * one-tap rebrand automatically.
 */
export default function PrintLogoHeader({ docTitle }) {
  const [dealership, setDealership] = useState("");
  useEffect(() => {
    let cancelled = false;
    api
      .get("/settings")
      .then((r) => {
        if (!cancelled) setDealership(r.data?.dealership_name || "");
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      className="mb-6 bg-navy text-white px-3 py-1 rounded-lg flex items-center gap-4 print:rounded-none shadow-sm"
      data-testid="print-logo-header"
    >
      <img
        src="/logo-brand.png"
        alt="Decline Drive — We Drive Further"
        className="h-32 md:h-40 w-auto object-contain shrink-0"
        data-testid="print-logo-img"
      />
      <div className="ml-auto text-right min-w-0">
        {docTitle && (
          <div className="font-mono-label text-[hsl(var(--gold-light))] text-[0.65rem] tracking-widest">
            {docTitle}
          </div>
        )}
        {dealership && (
          <div
            className="font-mono-label text-white/70 text-[0.6rem] tracking-widest mt-1"
            data-testid="print-header-dealer"
          >
            PREPARED FOR{" "}
            <span className="text-[hsl(var(--gold-light))] font-bold">
              {dealership.toUpperCase()}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
